import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import FolderItem from './FolderItem';
import { useBookmarks } from '../../contexts/BookmarkContext';

const FolderTree = ({ folders, ...props }) => {
  const { highlightId } = useBookmarks();
  const rootFolders = folders.filter(f => !f.parent).sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <Droppable droppableId="root-folders" type="folder">
      {(provided) => (
        <div {...provided.droppableProps} ref={provided.innerRef} className="space-y-1">
          {rootFolders.map((folder, index) => (
            <FolderItem 
              key={folder.id} 
              folder={folder} 
              folders={folders} 
              index={index} 
              highlightId={highlightId}
              {...props} 
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default FolderTree;